import { render, staticRenderFns } from "./LottieCheck.vue?vue&type=template&id=b51e06dc&scoped=true&"
import script from "./LottieCheck.vue?vue&type=script&lang=js&"
export * from "./LottieCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51e06dc",
  null
  
)

export default component.exports